import { Alert } from "AWS-UI-Components-React"

export class SelfServiceAlert extends React.Component {

    render () {
        return (
            <div>
                <Alert type={this.props.alertType} header={this.props.alertHeader} content={this.props.alertContent}/>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/spotlight/self-service-alert.jsx